import api from '../utils/api';
import { MENU_ENDPOINTS } from './endpoints/menu.endpoints';
import type { LeftMenuApiItem, MenuPermission, TopMenuItem } from './types/menu.types';

export const menuService = {
  getTopMenus: () => api.get<{ data: TopMenuItem[] }>(MENU_ENDPOINTS.top),

  getLeftMenu: (menuId: number) =>
    api.get<{ data: LeftMenuApiItem[] }>(MENU_ENDPOINTS.left(menuId)),

  getRoutes: <T = { component: string; path: string }[]>() => api.get<T>(MENU_ENDPOINTS.routes),

  getPermissions: (pageId: number) =>
    api.get<{ data: MenuPermission[] }>(MENU_ENDPOINTS.permissions(pageId)),

  getTabs: (pageId: number) =>
    api.get<{ data: { name: string; menuId: number }[] }>(MENU_ENDPOINTS.tab(pageId)),
};
